import React from "react";
import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MainPage from "./components/main-page";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-cyan/theme.css";
// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <PrimeReactProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <MainPage />
        </BrowserRouter>
      </QueryClientProvider>
    </PrimeReactProvider>
  );
}

export default App;
